import { Card, CardContent, Stack, Box, Typography } from "@mui/material";
import { SEMANTIC } from "../theme/brand";

const TONES = {
  pipeline: { color: SEMANTIC.pipeline, tint: SEMANTIC.pipelineTint },
  revenue: { color: SEMANTIC.revenue, tint: SEMANTIC.revenueTint },
  potential: { color: SEMANTIC.potential, tint: SEMANTIC.potentialTint },
  expansion: { color: SEMANTIC.expansion, tint: SEMANTIC.pipelineTint },
  warning: { color: SEMANTIC.warning, tint: SEMANTIC.warningTint },
  danger: { color: SEMANTIC.danger, tint: SEMANTIC.dangerTint },
  neutral: { color: SEMANTIC.neutral, tint: SEMANTIC.neutralTint },
};

/** Tarjeta de indicador: etiqueta arriba, valor grande, explicación corta abajo. El tono indica qué mide. */
export default function KpiCard({ label, value, helper, icon, tone = "pipeline" }) {
  const t = TONES[tone] || TONES.pipeline;
  return (
    <Card variant="outlined" sx={{ height: "100%", borderTop: `3px solid ${t.color}` }}>
      <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: { xs: 1.5, sm: 2 } } }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
          <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1.4, fontSize: { xs: 10, sm: 11 } }}>
            {label}
          </Typography>
          {icon && (
            <Box
              sx={{
                flexShrink: 0,
                width: 32,
                height: 32,
                borderRadius: "50%",
                bgcolor: t.tint,
                color: t.color,
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                justifyContent: "center",
                "& svg": { fontSize: 18 },
              }}
            >
              {icon}
            </Box>
          )}
        </Stack>
        <Typography
          variant="h5"
          component="p"
          sx={{ mt: 0.5, color: tone === "revenue" ? t.color : "text.primary", letterSpacing: "0.02em", fontSize: { xs: "1.25rem", sm: "1.5rem" }, overflowWrap: "anywhere" }}
        >
          {value}
        </Typography>
        {helper && (
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.25 }}>
            {helper}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
